// DS: I37
// from GDrive
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const FavouriteOutfilled: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M12 4L9.064 9.367 3 10.47l4.25 4.42-.812 6.05 5.561-2.635 5.562 2.634-.812-6.049L21 10.471l-6.065-1.104L12 4zM8.823 15.103l.103-.759-.532-.554-2.199-2.287 3.153-.573.746-.137.363-.664 1.541-2.82 1.542 2.82.364.664.746.137 3.153.573-2.2 2.287-.532.554.103.76.423 3.149-2.918-1.383-.68-.322-.68.322-2.918 1.383.422-3.15z" />
      </g>
    </svg>
  </IconWrap>
);
FavouriteOutfilled.displayName = 'FavouriteOutfilled';

export default FavouriteOutfilled;
